import { render, staticRenderFns } from "./ContestHomeCategoryComponent.vue?vue&type=template&id=18156b09"
import script from "./ContestHomeCategoryComponent.vue?vue&type=script&lang=js"
export * from "./ContestHomeCategoryComponent.vue?vue&type=script&lang=js"
import style0 from "./ContestHomeCategoryComponent.vue?vue&type=style&index=0&id=18156b09&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports